import { Link as RouterLink } from 'react-router';

import type { ReactNode } from 'react';

import { Box, styled } from '@mui/material';

import { Colors } from 'Themes/colors';

const Container = styled(Box)`
  display: flex;
  align-items: center;
  gap: 9px;
  color: ${Colors.blue};
`;

export const linkStyle = `
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 100%;
  text-decoration-line: underline;
  white-space: nowrap;
  cursor: pointer;
  color: ${Colors.blue} !important;
  &:visited {
    color: ${Colors.blue} !important;
  }
`;

const StyledLink = styled(RouterLink)`
  ${linkStyle}
`;

type Props = {
  to: string;
  label: string;
  leftIcon?: ReactNode;
  shouldOpenInNewTab?: boolean;
  state?: unknown;
};

export const Link = ({
  to,
  label,
  leftIcon,
  shouldOpenInNewTab = true,
  state
}: Readonly<Props>) => {
  const isExternal = to.startsWith('http://') || to.startsWith('https://');

  return (
    <Container>
      {leftIcon}
      {isExternal ? (
        <a
          href={to}
          target={shouldOpenInNewTab ? '_blank' : '_self'}
          rel={shouldOpenInNewTab ? 'noopener noreferrer' : undefined}
          style={{
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '100%',
            textDecorationLine: 'underline',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            color: Colors.blue
          }}
        >
          {label}
        </a>
      ) : (
        <StyledLink to={to} target={shouldOpenInNewTab ? '_blank' : '_self'} state={state}>
          {label}
        </StyledLink>
      )}
    </Container>
  );
};
